import { LoginResource } from "../plain/LoginResource";
const authMiddleware = ({ dispatch }) => next => async (action) => {
    switch (action.type) {
        case "rest-hooks/purge":
        case "rest-hooks/rpc":
        case "rest-hooks/receive":
            if (action.error &&
                action.payload.status === 401 &&
                action.meta.schema.urlRoot !== LoginResource.urlRoot) {
                // TODO: dispatch auth system
                // dispatch({ type: "rest-hooks/reset" }); // requires rest-hooks>= 2.2.0
                window.location.reload();
            }
            next(action);
            break;
        default:
            next(action);
            return;
    }
};
export class AuthManager {
    constructor() {
        this.getMiddleware = () => authMiddleware;
    }
    cleanup() { }
}
//# sourceMappingURL=AuthManager.js.map